import React, { useState } from "react";
import {ParolaGosterge, PasswordText} from "../index";
import {formatMessage} from "devextreme/localization";
import Validator, {RequiredRule} from "devextreme-react/validator";
import {formatMessageExt} from "../../utils/helpers";

// testing only
// const kurallar = [
//     {"type":"min","enabled":true,"id":"validation.minLength","vars":["",8]},
//     {"type":"max","enabled":true,"id":"validation.maxLength","vars":["",16]},
//     {"type":"number","enabled":true,"id":"validation.containsNum","vars":[""]},
//     {"type":"lower","enabled":true,"id":"validation.containsLower","vars":[""]},
//     {"type":"upper","enabled":true,"id":"validation.containsUpper","vars":[""]},
//     {"type":"char","enabled":true,"id":"validation.containsChar","vars":["","\"!'^+%&\/()=?_-*@.,#<>"]}
//     ]
// ;

export default React.memo(({ disabled, parolaSor, onValueChanged}) => {
    const [parola, setParola] = useState('');
    const [parolaYeni, setParolaYeni] = useState('');
    const [parolaTekrar, setParolaTekrar] = useState('');
    const [dogrulandi, setDogrulandi] = useState(false);

    const validated = dogrulandi && parolaYeni === parolaTekrar;

    if (onValueChanged) {
        if (parolaSor) {
            onValueChanged({validated, parola, parolaYeni, parolaTekrar})
        } else {
            onValueChanged({validated, parolaYeni, parolaTekrar})
        }
    }

    return <div className='text-center mt-4 black-text'>
        {parolaSor && <PasswordText placeholder={formatMessage('sifreDegistir.sifre')}
                                    readOnly={disabled}
                                    defaultValue={parola}
                                    displayButton={true}
                                    onValueChanged={(e)=> setParola(e.value)}>
            <Validator>
                <RequiredRule message={formatMessageExt('validation.isRequired', ['sifre'])} />
            </Validator>
        </PasswordText>}

        <br/>
        <PasswordText placeholder={formatMessage('sifreDegistir.sifreYeni')}
                      readOnly={disabled}
                      defaultValue={parolaYeni}
                      value={parolaYeni}
                      displayButton={false}
                      onValueChanged={(e)=> setParolaYeni(e.value)}>
            <Validator>
                <RequiredRule message={formatMessageExt('validation.isRequired', ['sifre'])} />
            </Validator>
        </PasswordText>

        <br/>
        <PasswordText placeholder={formatMessage('sifreDegistir.sifreTekrar')}
                      readOnly={disabled}
                      defaultValue={parola}
                      value={parola}
                      displayButton={false}
                      onValueChanged={(e)=> setParolaTekrar(e.value)}>
            <Validator>
                <RequiredRule message={formatMessageExt('validation.isRequired', ['sifre'])} />
            </Validator>
        </PasswordText>

        <br/>
        <ParolaGosterge parola={parolaYeni}
                        dogrula={(sonuc) => {
                            if (sonuc !== dogrulandi) {
                                setDogrulandi(sonuc)
                            }
                        }}/>
    </div>
});
